<template>
    <div class="selfContainer">
        <div class="head">
            <div>
                <img :src="userInfo.cover" alt="">
                <div>
                    <h2>{{userInfo.nickName}}</h2>
                    <p>{{userInfo.userName}}</p>
                </div>
            </div>
        </div>
        <p v-show="isShowExpireDate">会员到期时间：{{expireDate}}</p>
        <ul class="contral">
            <li @click="goList('collect')">
                <i></i>
                <p>收藏</p>
                <i></i>
            </li>
            <li @click="goList('history')">
                <i></i>
                <p>足迹</p>
                <i></i>
            </li>
            <li @click="goAboutUs">
                <i></i>
                <p>关于我们</p>
                <i></i>
            </li>
            <li @click="changePwd" v-show="initialPasd">
                <i></i>
                <p>修改密码</p>
                <i></i>
            </li>
            <li @click="logout" v-show="!hideLogout">
                <i></i>
                <p>注销</p>
                <i></i>
            </li>
            
        </ul>
    </div>
</template>
<script>
let Base64 = require('js-base64').Base64;
export default {
    // name: "我的页面"
    data () {
        return {
            userInfo: {
                cover: (!localStorage.getItem("headPortrait") || localStorage.getItem("headPortrait") == 'null')  ? require('../assets/imgs/self/admin.png') : localStorage.getItem("headPortrait"),
                nickName: (!localStorage.getItem("nickName") || localStorage.getItem("nickName") == 'null') ? "--" : localStorage.getItem("nickName"),
                userName: (!localStorage.getItem("userName") || localStorage.getItem("userName") == 'null') ? "--" : localStorage.getItem("userName")
            },
            initialPasd: false,
            expireDate: localStorage.getItem("expireDate") != -1 ? localStorage.getItem("expireDate") : "",
            isShowExpireDate: localStorage.getItem("expireDate") != -1 ? true : false,
            hideLogout: false,
        }
    },
    computed: {
        isLogout() {
            return this.$store.state.isLogout;
        }
    },
    created() {
        var that = this;
        if( localStorage.getItem("hideLogout") == 1 ) {
            that.hideLogout = true;
        }
        if( that.$route.query.result ) {
            // console.log(that.$route.query.result)
            // console.log(Base64.decode(decodeURI(that.$route.query.result)));
            // console.log(Base64.decode(that.$route.query.result));
            // 昵称
            localStorage.setItem("nickName", JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.nickName);
            // 用户名
            if( JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.userName ) {
                localStorage.setItem("userName", JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.userName);
            }
            
            // 用户头像
            localStorage.setItem("headPortrait", JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.headPortrait);
            // 是否登录
            localStorage.setItem("status", JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.status);
             // sessionId
            localStorage.setItem("ticket", JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.ticket);

            // 某些机构第一次登陆提示修改密码
            localStorage.setItem("initialPasd", JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.initialPasd);
            if( JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.initialPasd == 1 ) {
                let data = {
                    msg: "请修改初始密码"
                }
                that.$emit("dialogChange", data);
            }

            // 用户账号到期时间
            if( JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.expireDate ) {
                localStorage.setItem("expireDate", JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.expireDate);
            }else{
                localStorage.setItem("expireDate", -1);
            }
            // 用户账号类型 0是会员  1是普通
            localStorage.setItem("userType", JSON.parse(Base64.decode(decodeURI(that.$route.query.result))).data.userType);
            
            localStorage.removeItem("showRowNum");

            that.userInfo = {
                cover: (!localStorage.getItem("headPortrait") || localStorage.getItem("headPortrait") == 'null')  ? require('../assets/imgs/self/admin.png') : localStorage.getItem("headPortrait"),
                nickName: (!localStorage.getItem("nickName") || localStorage.getItem("nickName") == 'null') ? "--" : localStorage.getItem("nickName"),
                userName: (!localStorage.getItem("userName") || localStorage.getItem("userName") == 'null') ? "--" : localStorage.getItem("userName")
            }

        }
        if( (localStorage.getItem("status") == "false" || !localStorage.getItem("status")) ) {
            that.$router.push("/login");
        }
        
        if( localStorage.getItem("initialPasd") == 1 ) {
            that.initialPasd = true;
        }else{
            that.initialPasd = false;
        }
    },
    methods: {
        goList(type) {
            var that = this;
            var data = {
                type: type,
                name: type == 'collect' ? '收藏列表' : '历史记录'
            }
            that.$router.push({
                path: "/classBookList",
                query: data
            });
        },
        goAboutUs(){
            var that = this;
            // that.$router.push("/aboutUs");
            location.href = "https://mp.weixin.qq.com/s/pseCoe3BvgtJTFV62l20rw";
        },
        logout() {
            let that = this;
            let data = {
                msg: "确认退出？",
                type: "logout"
            }
            that.$emit("dialogChange", data)
            // var isLogout = confirm("确认退出？");
            // if( !isLogout ) {
            //     return false;
            // }else{
            //     var that = this;

            //     var data = {
            //         ticket: localStorage.getItem("ticket")
            //     }
            //     that.allApi.logout(data).then(function(resource) {
            //         // console.log(resource.data);
            //         if( resource.data.data.flag && that.$rsa.checkSign(localStorage.getItem("puk"), resource.data.data.message, resource.data.data.sign) ) {

            //             localStorage.removeItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory");
            //             // 昵称
            //             localStorage.setItem("nickName", JSON.parse(resource.data.data.message).nickName);
            //             // 用户名
            //             localStorage.setItem("userName", JSON.parse(resource.data.data.message).userName);
            //             // 用户头像
            //             localStorage.setItem("headPortrait", JSON.parse(resource.data.data.message).headPortrait);
            //             // 是否登录
            //             localStorage.setItem("status", JSON.parse(resource.data.data.message).status);

            //             that.$router.push("/login");
            //         }
            //     });
            // }
            
        },
        loginApi() {
            var that = this;

            var data = {
                ticket: localStorage.getItem("ticket")
            }
            that.allApi.logout(data).then(function(resource) {
                // console.log(resource.data);
                // if( resource.data.data.flag && that.$rsa.checkSign(localStorage.getItem("puk"), resource.data.data.message, resource.data.data.sign) ) {
                if( resource.data.data.flag ) {

                    localStorage.removeItem(localStorage.getItem("officeId") + localStorage.getItem("classTypeId") + "searchHistory");
                    // 昵称
                    localStorage.setItem("nickName", JSON.parse(resource.data.data.message).nickName);
                    // 用户名
                    localStorage.setItem("userName", JSON.parse(resource.data.data.message).userName);
                    // 用户头像
                    localStorage.setItem("headPortrait", JSON.parse(resource.data.data.message).headPortrait);
                    // 是否登录
                    localStorage.setItem("status", JSON.parse(resource.data.data.message).status);

                    that.$router.push("/login");
                }
            });
        },
        changePwd() {
            let that = this;
            that.$router.push("/changePwd");
        }
    },
    watch: {
        isLogout( newV ) {
            let that = this;
            if( newV ) {
                that.$store.commit("setIsLogout", false);
                that.loginApi();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@function rem($args) {
  $uiWidth: 75px;
  @return $args/$uiWidth * 1rem;
}
.selfContainer{
    position: absolute;
    left: 0;
    width: 100%;
    bottom: 0;
    top: 0;
    background: #fff;
    overflow: hidden;
    .head{
        padding: rem(30px) rem(40px) 0;
        margin-bottom: rem(30px);
        >div{
            padding: rem(40px) rem(40px) rem(56px);
            display: flex;
            background: #FBFCFE;
            box-shadow: 0 rem(12px) rem(24px) 0 #BFD1E3;
            border-radius: rem(6px);
            >img{
                display: block;
                width: rem(120px);
                height: rem(120px);
                border-radius: rem(120px);
                margin-right: rem(30px);
            }
            >div{
                flex: 1;
                display: flex;
                justify-content: center;
                flex-direction: column;
                >h2{
                    color: #111;
                    font-size: rem(32px);
                    line-height: rem(45px);
                    margin-bottom: rem(5px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                >p{
                    color: #999;
                    font-size: rem(28px);
                    line-height: rem(40px);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
    >p{
        padding: 0 rem(60px);
        color: #999;
        font-size: rem(24px);
        // margin-bottom: rem(30px);
    }
    .contral{
        padding-left: rem(60px);
        >li{
            height: rem(100px);
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #E5E5E5;
            >i:first-of-type{
                display: block;
                width: rem(30px);
                height: rem(30px);
                margin-right: rem(20px);
                background: #000;
            }
            >p{
                flex: 1;
                font-size: rem(28px);
                color: #333;
                line-height: rem(40px);
            }
            >i:last-of-type{
                display: block;
                width: rem(17px);
                height: rem(17px);
                margin-left: rem(20px);
                margin-right: rem(60px);
                background: url('../assets/imgs/self/mineMore.png') center / rem(17px) no-repeat;
            }
            &:first-child{
                >i:first-of-type{
                    background: url('../assets/imgs/self/collect.png') center / rem(30px) no-repeat;
                }
            }
            &:nth-child(2){
                >i:first-of-type{
                    background: url('../assets/imgs/self/history.png') center / rem(30px) no-repeat;
                }
            }
            &:nth-child(3){
                >i:first-of-type{
                    background: url('../assets/imgs/self/aboutIcon.png') center / rem(30px) no-repeat;
                }
            }
            &:nth-child(4){
                >i:first-of-type{
                    background: url('../assets/imgs/self/zhuxiao.png') center / rem(30px) no-repeat;
                }
            }
            &:last-child{
                >i:first-of-type{
                    background: url('../assets/imgs/self/changePwd.png') center / rem(30px) no-repeat;
                }
            }
        }
    }
} 
</style>
